export default landscapeModalCtrl

/** @ngInject */
function landscapeModalCtrl($scope, $uibModalInstance, landscapeQuestions, idContract, isEdition) {
    $scope.contract = { id: idContract, isDraft: true }
    $scope.landscapeQuestions = landscapeQuestions
    $scope.popupInstance = $uibModalInstance
    $scope.isEdition = isEdition.edition
    $scope.isNew = isEdition.new

    $scope.close = function () {
        const landCanvas = document.getElementById('landscape-canvas')
        $uibModalInstance.close({ canvas: landCanvas })
    }
}



// WEBPACK FOOTER //
// ./src/states/subscription/modal/landscapeModalCtrl.js